import React, { useState } from 'react';
import { Button, Spinner, Dropdown } from 'react-bootstrap';
import { ClockHistory } from 'react-bootstrap-icons';
import { REPORT_GENERATION_MODES } from '../../helpers/constants';
import { ChevronDown } from 'lucide-react';
import { TbFilesOff, TbFiles } from 'react-icons/tb';
const ReportActionBar = ({
  onPreviewHistory,
  onSaveReport,
  onGenerateReport,
  onQuickPreview,
  isGeneratingReport,
  isSaving,
  reportGenerationMode
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="bg-white w-100 pb-3 px-2" style={{ position: 'absolute', bottom: 0, right: 0 }}>
      <hr className="mt-0 mb-2 p-0" />
      <div className="d-flex justify-content-between">
        <Button
          variant="outline-light text-dark border-dark-grey d-flex align-items-center"
          onClick={onPreviewHistory}
          disabled={isGeneratingReport || isSaving}
        >
          <ClockHistory className="mr-1" />
          Report History
        </Button>

        <div className="d-flex justify-content-between">
          <Button
            variant="outline-light text-dark border-dark-grey"
            className="mr-2"
            onClick={onSaveReport}
            disabled={isGeneratingReport || isSaving}
          >
            {isSaving && <Spinner size="sm" animation="border" variant="dark mr-1" />}
            {isSaving ? 'Saving...' : 'Save'}
          </Button>

          <Button
            variant="primary"
            onClick={onGenerateReport}
            className="mr-2"
            disabled={isGeneratingReport || isSaving}
          >
            {isGeneratingReport && reportGenerationMode === REPORT_GENERATION_MODES.PREVIEW_AND_SHARE && (
              <Spinner size="sm" animation="border" variant="dark" className="mr-1" />
            )}
            {isGeneratingReport && reportGenerationMode === REPORT_GENERATION_MODES.PREVIEW_AND_SHARE
              ? 'Loading Report...'
              : 'Preview & Share'}
          </Button>

          <Button variant="dark" onClick={onQuickPreview} disabled={isGeneratingReport || isSaving}>
            {isGeneratingReport && reportGenerationMode === REPORT_GENERATION_MODES.QUICK_PREVIEW && (
              <Spinner size="sm" animation="border" variant="light" className="mr-1" />
            )}
            {isGeneratingReport && reportGenerationMode === REPORT_GENERATION_MODES.QUICK_PREVIEW
              ? 'Loading Report...'
              : '⚡ Quick Preview'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReportActionBar;
